import {projectId_} from "../../wenxing/constants";

export function goBack() {
  window._vm.$router.go(-1);
  return false;
}

export function push(str, options) {
  var projectId =
    (window._vm.$store.state.message &&
      window._vm.$store.state.message.currentUser &&
      window._vm.$store.state.message.currentUser.projectId) ||
    window._vm.$route.query.projectId ||
    sessionStorage.getItem("projectId") || projectId_;
  if (projectId == "undefined") {
    projectId = sessionStorage.getItem("projectId") || projectId_;
  }
  var options_ = Object.assign(options || {}, {projectId, lang: sessionStorage.getItem('lang') || 'zh'});
  window._vm.$router.push({
    path: str,
    query: options_
  });
  return false;
}

export function replace(str, options) {
  var projectId =
    (window._vm.$store.state.message &&
      window._vm.$store.state.message.currentUser &&
      window._vm.$store.state.message.currentUser.projectId) ||
    window._vm.$route.query.projectId ||
    sessionStorage.getItem("projectId");
  if (projectId == "undefined") {
    projectId = sessionStorage.getItem("projectId");
  }
  var options_ = Object.assign(options || {}, {projectId,lang: sessionStorage.getItem('lang') || 'zh'});
  window._vm.$router.replace({
    path: str,
    query: options_
  });
  return false;
}

export function getUrlParamNative(n) {
  var e, r;
  return (
    (r = new RegExp("(^|&)" + n + "=([^&]*)(&|$)")),
      (e = location.search.substr(1).match(r)),
      null !== e ? decodeURI(e[2]) : null
  );
}

export function getQuery(str) {
  if (!str) return "";
  return window._vm && window._vm.$route && window._vm.$route.query[str];
}

export function getParams(str) {
  if (!str) return "";
  return window._vm && window._vm.$route && window._vm.$route.params[str];
}

export function getLangInUrl() {
  if (location.href.indexOf("=en") >= 0) {
    return "en" 
  }
  if (location.href.indexOf("=zh") >= 0) {
    return "zh" 
  }
  return ""
}



// WEBPACK FOOTER //
// ./src/common/utils/routerUtil.js